export class ValidationError {
  hasError: boolean;
  errorMessage: string;
  constructor(hasError: boolean) {
    this.hasError = hasError;
    this.errorMessage = 'Required';
  }
}
